export const DOMAIN = process.env.REACT_APP_API_DOMAIN || '';
export const BILLING_MIN_RUB = 1;
export const BILLING_MAX_RUB = 10_000;
export const PROD = process.env.REACT_APP_PROD || '';